import { useEffect } from 'react';
import { prefetchPath } from '../lib/routePrefetch';

// Globally warms the code-split chunk for any internal treatment link on hover/focus/touch.
export const RoutePrefetcher = () => {
  useEffect(() => {
    const handle = (e) => {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || !href.startsWith('/')) return; // same-origin internal routes only
      prefetchPath(href.split('?')[0].split('#')[0]);
    };
    document.addEventListener('mouseover', handle, { passive: true });
    document.addEventListener('focusin', handle, { passive: true });
    document.addEventListener('touchstart', handle, { passive: true });
    return () => {
      document.removeEventListener('mouseover', handle);
      document.removeEventListener('focusin', handle);
      document.removeEventListener('touchstart', handle);
    };
  }, []);

  return null;
};

export default RoutePrefetcher;
